module.exports = __webpack_public_path__ + "static/img/20261104_2.71f55e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/20261104_2.jpg
// module id = fLO5
// module chunks = 98